import { IWatchdogState } from "utils/search/types";

export enum EApiWatchdogFrequencyId {
  NEVER = "NEVER",
  IMMEDIATE = "IMMEDIATE",
  ONCE_PER_8_HOURS = "ASAP",
  ONCE_PER_DAY = "ONCE_PER_DAY",
  ONCE_PER_WEEK = "ONCE_PER_WEEK",
}

export interface IWatchdog {
  id: number;
  name: string;
  frequencyId: EApiWatchdogFrequencyId;
  filter: IWatchdogState;
}
